<template>
    <div class="col-xxl-3 col-xl-6 cols-xl-25 col-md-6 box-col-6">
        <div class="card">
          <div class="card-body">
                    <div class="default-datepicker online-date">
                        <Datepicker1 class="datepicker-here" inline autoApply v-model="date1" range data-language="en"></Datepicker1>
                    </div>
                </div>
        </div>
      </div>
</template>
<script>
import Datepicker1 from '@vuepic/vue-datepicker';
  import '@vuepic/vue-datepicker/dist/main.css'

export default{
    name: 'datePicker',
    components: { Datepicker1 },
        data() {
            return {
                
                date1: new Date()
            };
        }
    }

</script>